import { render, staticRenderFns } from "./articulos_create.vue?vue&type=template&id=cce6a1ca&scoped=true&"
import script from "./articulos_create.vue?vue&type=script&lang=js&"
export * from "./articulos_create.vue?vue&type=script&lang=js&"
import style0 from "./articulos_create.vue?vue&type=style&index=0&id=cce6a1ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce6a1ca",
  null
  
)

export default component.exports